"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _space = _interopRequireDefault(require("../../styles/space"));

var heroDefaults = {
  alignItems: 'center',
  bannerTextColor: 'light',
  buttonVariant: 'primary',
  buttonInverted: false,
  overlay: 'rgba(0, 0, 0, 0.2)',
  textColorArticle: 'offblack',
  textOnlyAlignItems: 'center',
  textOnlyTitleSize: 'large',
  textOnlyPadding: '1.4rem',
  textColor: {
    standard: 'white',
    inverted: 'black'
  },
  textShadow: '0 0 3px #000000, 0 0 30px rgba(0, 0, 0, 0.9)',
  textShadowInverted: 'none',
  titleSize: 'large',
  subtitleSize: 'small',
  titleTransform: 'none',
  wrapBorder: {
    width: '0',
    style: 'none',
    color: 'none'
  },
  standardPaddingSmall: '2.4rem 1.6rem 3.2rem 1.6rem',
  standardPaddingXLarge: '2.8rem 4.8rem',
  standardPaddingMobile: '1.4rem',
  buttonBoxShadow: 'none',
  // Large
  largeAlignItems: 'center',
  largeLineHeight: 'inherit',
  heroLargeColumnWidth: [12, 12, 12, 12, 8],
  // Image Article
  articleColumnWidth: [12, null, 10, 8],
  articleTitleSize: 'xsmall'
};
var hero = {
  horizon: heroDefaults,
  cannesLions: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    buttonInverted: true
  }),
  lionsLive: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    textShadow: 'none',
    textShadowInverted: '0 0 3px #000000, 0 0 30px rgba(0, 0, 0, 0.9)',
    overlay: 'transparent',
    wrapBorder: {
      width: '1px',
      style: 'solid',
      color: 'greymid'
    },
    textColor: {
      standard: 'black',
      inverted: 'white'
    },
    textColorArticle: 'black',
    bannerTextColor: 'light',
    titleTransform: 'uppercase',
    alignItems: 'left'
  }),
  money2020: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    buttonVariant: 'secondary',
    fontStyle: 'italic',
    fontWeight: 'normal',
    buttonBoxShadow: '0 0 10px 0 #000000'
  }),
  ascential: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    titleTransform: 'uppercase',
    fontStyle: 'italic'
  }),
  dcl: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    largeAlignItems: 'flex-start',
    heroLargeColumnWidth: [12],
    standardPaddingSmall: '2.4rem 1.6rem 3.2rem 0.8rem',
    standardPaddingXLarge: '2.8rem 4.8rem 2.8rem 0.8rem',
    standardPaddingMobile: '1.4rem 1.4rem 1.4rem 0',
    textColor: {
      standard: 'white',
      inverted: 'primary'
    },
    textShadow: 'none',
    titleSize: 'medium',
    alignItems: 'left'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, heroDefaults), {}, {
    alignItems: 'left',
    buttonVariant: 'secondary',
    fontWeight: 'normal',
    textShadow: 'none',
    overlay: 'transparent',
    paddingBottomOnLarge: _space.default.large,
    textOnlyTitleSize: 'large',
    textOnlyPadding: '0',
    textColor: {
      standard: 'primary',
      inverted: 'white'
    },
    bannerTextColor: 'light',
    standardPaddingSmall: '2.4rem 0.8rem',
    standardPaddingXLarge: '2.8rem 0.8rem',
    standardPaddingMobile: '1.4rem 0rem',
    // Image Article
    articleColumnWidth: [12, null, 10, 10],
    articleTitleSize: 'large',
    subtitleSize: 'xsmall'
  })
};
var _default = hero;
exports.default = _default;